import './App.css';
import TextInput from './components/WordCounter';

function App() {
  return (
    <>
    <TextInput></TextInput>
    </>

  );
}

export default App;
